import React from 'react';
import PropTypes from 'prop-types';
import nds from '@nerdwallet/base-styles/classes';

import { Heading } from '@nerdwallet/react-typography';
import Row from '../row/row';
import AppButtons from '../app-buttons/app-buttons';
import VerticalSpacer from '../vertical-spacer/vertical-spacer';

import { stringInputSpec } from '../../lib/editing-configs';

import './app-row.less';

/*
 * Row container for native app links.
 */
const AppRow = ({ appStoreURL, backgroundColor, googlePlayURL, title }) => (
  <Row className="app-row" backgroundColor={backgroundColor}>
    <Row centeredInParent standardMaxWidths>
      <VerticalSpacer mobile="p-40" tablet="p-40" desktop="p-40" />
      <Heading className={nds('text-align-center')} level={3}>
        {title}
      </Heading>
      <VerticalSpacer mobile="p-40" tablet="p-40" desktop="p-18" />
      <AppButtons
        className="app-row__text-me-container"
        appStoreURL={appStoreURL}
        googlePlayURL={googlePlayURL}
      />
      <VerticalSpacer mobile="p-40" tablet="p-40" desktop="p-40" />
    </Row>
  </Row>
);

AppRow.propTypes = {
  backgroundColor: PropTypes.string,
  title: PropTypes.string,
  appStoreURL: PropTypes.string,
  googlePlayURL: PropTypes.string,
};

AppRow.getEditingConfig = () => [
  stringInputSpec('title', 'Section title'),
  ...AppButtons.getEditingConfig(),
];

AppRow.displayName = 'AppRow';

export default AppRow;
